import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Settings2 } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { NewsTicker } from './NewsTicker';
import { AnnouncementsManager } from './AnnouncementsManager';
import { UrgentAnnouncementModal } from './UrgentAnnouncementModal';
import { useOpenAnnouncementLink } from '../lib/announcementLinks';

const REFRESH_MS = 120000;

const usePolling = (fetcher) => {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => {
    try { setItems((await fetcher()) || []); } catch (e) { /* bandeau non bloquant */ }
  }, [fetcher]);
  useEffect(() => {
    load();
    const t = setInterval(load, REFRESH_MS);
    return () => clearInterval(t);
  }, [load]);
  return [items, load];
};

const staffFetch = async () => (await api.get('/announcements/active')).data;

export const StaffNewsTicker = ({ className = '' }) => {
  const { user } = useAuth();
  const canManage = ['admin', 'super_admin'].includes(user?.role);
  const [items, reload] = usePolling(staffFetch);
  const [open, setOpen] = useState(false);
  const openLink = useOpenAnnouncementLink();
  if (!items.length && !canManage) return null;

  const action = canManage ? (
    <button
      type="button" onClick={() => setOpen(true)}
      className="flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-semibold text-[#F6D58E] hover:bg-white/10 transition-colors"
      data-testid="ticker-manage-btn"
    >
      <Settings2 className="w-4 h-4" /> <span className="hidden sm:inline">Gérer</span>
    </button>
  ) : null;

  return (
    <>
      <NewsTicker items={items} action={action} className={className} onOpen={openLink} />
      {canManage && <AnnouncementsManager open={open} onClose={() => setOpen(false)} onChanged={reload} />}
    </>
  );
};

export const StaffUrgentAlert = () => {
  const [items] = usePolling(staffFetch);
  const openLink = useOpenAnnouncementLink();
  return <UrgentAnnouncementModal items={items} scope="staff" onOpen={openLink} />;
};

export const PortalNewsTicker = ({ portal }) => {
  const fetcher = useCallback(async () => {
    const tk = localStorage.getItem(`${portal}_token`);
    if (!tk) return [];
    const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/${portal}/announcements`, { headers: { Authorization: `Bearer ${tk}` } });
    return r.data;
  }, [portal]);
  const [items] = usePolling(fetcher);
  const openLink = useOpenAnnouncementLink();
  if (!items.length) return null;
  return (
    <>
      <NewsTicker items={items} className="rounded-none border-x-0 border-t-0" onOpen={openLink} />
      <UrgentAnnouncementModal items={items} scope={portal} onOpen={openLink} />
    </>
  );
};
